import { useMutation, gql } from "@apollo/client"

const DELETE_GROUP_MUTATION = gql`
  mutation DeleteGroup($id: ID!) {
    deleteGroup(id: $id)
  }
`

const useMutationDeleteGroup = () => useMutation(DELETE_GROUP_MUTATION)

export { useMutationDeleteGroup }
